// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","form":"form-1LDSH","infoMessages":"infoMessages-19iw3","label":"label-y8iU_"};